import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import { LanguageProvider } from "./context/LanguageContext";
import { Toaster } from "./components/ui/sonner";


import { AuthProvider } from "./config/AuthContext";
import MainRoutes from "./routes/MainRoute";

import "./App.css";

function App() {
    return (
        <AuthProvider>
            <ThemeProvider>
                <LanguageProvider>
                    <div className="App">
                        <BrowserRouter>
                            <MainRoutes />
                        </BrowserRouter>
                        <Toaster position="top-right" richColors />
                    </div>
                </LanguageProvider>
            </ThemeProvider>
        </AuthProvider>
    );
}

export default App;